"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchBar = void 0;
var InputIcon_1 = __importDefault(require("@components/InputIcon"));
var ItemLogDatePicker_1 = require("@features/ItemLogPage/components/SearchBar/ItemLogDatePicker");
var querryUtil_1 = require("@features/ItemLogPage/util/querryUtil");
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var react_use_1 = require("react-use");
var FilterBar_1 = require("./FilterBar");
var TopBarPagination_1 = __importDefault(require("./TopBarPagination"));
function SearchBar(_a) {
    var _b;
    var filterId = _a.filterId, searchParams = _a.searchParams, setSearchParams = _a.setSearchParams, countRequestQueryOption = _a.countRequestQueryOption, defaultStartDate = _a.defaultStartDate, searchInputValue = _a.searchInputValue, setSearchInputValue = _a.setSearchInputValue, paginate = _a.paginate, refreshTimestamp = _a.refreshTimestamp, minDate = _a.minDate, transformedData = _a.transformedData, isLoading = _a.isLoading;
    var t = (0, react_i18next_1.useTranslation)().t;
    var statuses = querryUtil_1.STATUSES.map(function (status) { return (__assign(__assign({}, status), { label: t(status.label) })); });
    var decisionResultTypes = [
        { id: 'auto', label: t('DASHBOARD.ITEM_LOG.DECISION_TYPE.AUTO'), prefix: 'metadata.automaticResults.result' },
        { id: 'manual', label: t('DASHBOARD.ITEM_LOG.DECISION_TYPE.MANUAL'), prefix: 'metadata.manualResults.result' },
        { id: 'remote', label: t('DASHBOARD.ITEM_LOG.DECISION_TYPE.REMOTE'), prefix: 'metadata.clientResults.result' },
    ];
    /** **
     * Manage search form callbacks
     */
    // We debounce the search input to avoid multiple requests
    var onSearchTextChange = (0, react_1.useCallback)(function (text) {
        var _a;
        // We debounce only if we add a character
        if (text && text.length > 0 && (searchParams === null || searchParams === void 0 ? void 0 : searchParams.id) && searchParams.id.length > 0 && text.length < ((_a = searchParams === null || searchParams === void 0 ? void 0 : searchParams.id) === null || _a === void 0 ? void 0 : _a.length)) {
            setSearchParams(__assign(__assign({}, searchParams), { id: text }));
        }
        setSearchInputValue(text);
    }, [searchInputValue, searchParams]);
    (0, react_use_1.useDebounce)(function () {
        setSearchParams(__assign(__assign({}, searchParams), { id: searchInputValue }));
    }, 500, [searchInputValue]);
    var onDecisionChange = function (decision) {
        setSearchParams(__assign(__assign({}, searchParams), { type: decision, currentPage: 0 }));
    };
    var onStatusChange = function (status) {
        var statusId = status === null || status === void 0 ? void 0 : status.id;
        if (statusId && ['MANUAL', 'new'].includes(statusId)) {
            setSearchParams(__assign(__assign({}, searchParams), { status: status || undefined, currentPage: 0, type: undefined }));
        }
        else {
            setSearchParams(__assign(__assign({}, searchParams), { status: status || undefined, currentPage: 0 }));
        }
    };
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("div", { className: "row" },
            react_1.default.createElement("div", { className: "col-md-12 search-header" },
                react_1.default.createElement("div", { className: "table-input", id: "top-bar" },
                    react_1.default.createElement(InputIcon_1.default, { wrapperClassName: "input-wrap", icon: "implioicons-search", iconClassName: "items-search-input-icon", id: "search-input", inputClassName: "form-control", onSearchTextChange: onSearchTextChange, placeholder: (_b = t('DASHBOARD.ITEM_LOG.SEARCH_BY_ID_PLACEHOLDER')) !== null && _b !== void 0 ? _b : '', value: searchInputValue || '' }),
                    react_1.default.createElement("div", { className: "rangePickerContainer" },
                        react_1.default.createElement(ItemLogDatePicker_1.ItemLogDatePicker, { setSearchParams: setSearchParams, searchParams: searchParams, defaultStartDate: defaultStartDate, fromParam: searchParams.from, toParam: searchParams.to, minDate: minDate })),
                    react_1.default.createElement(TopBarPagination_1.default, { isLoading: isLoading, countRequestQueryOption: countRequestQueryOption, paginate: paginate, filterId: filterId || '', refreshTimestamp: refreshTimestamp, transformedData: transformedData })))),
        react_1.default.createElement("div", { className: "row" },
            react_1.default.createElement("div", { className: "col-md-12" },
                react_1.default.createElement("div", { className: "status-tabs-container" },
                    react_1.default.createElement("div", { id: "status-tab" },
                        react_1.default.createElement(FilterBar_1.ResultsFilterBar, { statusList: statuses, activeStatus: searchParams.status, onStatusChange: onStatusChange, decisionList: decisionResultTypes, activeDecision: searchParams.type, onDecisionChange: onDecisionChange })))))));
}
exports.SearchBar = SearchBar;
